import ActionModal from "components/blocks/Modal/ActionModal";
import useMutation from "hooks/useMutation";
import { useTranslation } from "react-i18next";
import { BaseResponseType } from "services/shared-models/sharedTypes";
import {OrdersService} from "../../../../../../../../services/orders";


export type AddIterationsExaminerModalProps = {
    isOpen: boolean;
    onClose: (shouldUpdateExaminersTable: boolean) => void;
    selectedProgramOrderEvaluationId: number;
};

export const AddIterationsExaminerModal = ({ props }: { props?: AddIterationsExaminerModalProps | null }) => {
    const { t } = useTranslation(["Orders"]);
    const { mutateAsync:UpdateEvaluationOrderIterationsAsync, loading: UpdateEvaluationOrderIterationsLoading } = useMutation({
        queryFn: async (selectedProgramOrderEvaluationId: number) => {
            return await OrdersService.updateEvaluationOrderIterations(selectedProgramOrderEvaluationId);
        },
    });



    const onConfirm= async () => {
        let res: BaseResponseType<any>;
        res = (await UpdateEvaluationOrderIterationsAsync(props!.selectedProgramOrderEvaluationId)) as BaseResponseType<any>;
        if (!res.hasError) {
            props!.onClose(true);
        }
    };

    return (
        <ActionModal
            isOpen={props?.isOpen}
            onClose={() => props?.onClose(false)}
            headerMsg={t("AddIterationsRefereeModalHeaderMsg")}
            subMsg={t("AddIterationsRefereeModalSubMsg")}
            confirmBtnText={t("AddIteration")}
            actionIcon="icon-orders"
            iconWrapperColor="primary"
            onActionConfirm={onConfirm}
            loading={UpdateEvaluationOrderIterationsLoading}
        />
    );
};